import Modal from "./modal";

class ModalBlocked extends Modal {
  _DOMInit(el) {
    let wrapper = this._createWrapper();

    let mask = this._createMask();

    wrapper.appendChild(mask);
    wrapper.appendChild(el);
    

    let close = el.querySelector('[data-close]');
    if (close) {
      close.addEventListener('click', () => this.close());
    }

    return {
      wrapper: wrapper,
      mask: mask,
      element: el,
      close: close,

    }
  }

  _createWrapper() {
    let wrapper = document.createElement('div');
    wrapper.classList.add('popup-container');
    
    return wrapper;
  }

  _createMask() {
    let mask = document.createElement('div');
    mask.classList.add('popup-mask');
    mask.addEventListener('click', () => this.close());

    return mask;
  }

  _show() {
    document.body.appendChild(this.nodes.wrapper);
  }

  _hide() {
    this.nodes.wrapper.remove();
  }
}

export default ModalBlocked;